const shopParam = (shop) =>
  shop ? `&shopifyshopurl=${encodeURIComponent(shop)}` : "";

// Zoho CRM functions must be invoked on the merchant's own data-center host
// (a CA org's functions live on www.zohoapis.ca, EU on www.zohoapis.eu, …).
// Callers pass the org's dataCenterUrl; the US host is only a legacy fallback
// for callers that predate the parameter.
const DEFAULT_ZOHO_API_BASE = "https://www.zohoapis.com";

const buildFunctionUrl = (fnName, zapikey, settingId, shop, dataCenterUrl) => {
  const base = (dataCenterUrl || DEFAULT_ZOHO_API_BASE).replace(/\/+$/, "");
  return `${base}/crm/v7/functions/easyshopifyforzohocrm__${fnName}/actions/execute?auth_type=apikey&zapikey=${zapikey}&setting_id=${settingId}${shopParam(shop)}`;
};

const WEBHOOK_FUNCTION_BY_TRIGGER = {
  "customers/create": "customer_creation",
  "customers/update": "customer_update",
  "customers/delete": "customer_delete",
  "orders/create": "order_creation",
  "orders/updated": "order_update",
  "orders/delete": "order_delete",
  "products/create": "product_creation",
  "products/update": "product_update",
  "products/delete": "product_delete",
};

export const sampleWebhookBody = (
  settingId,
  zapikey,
  triggerApiName,
  shop,
  dataCenterUrl
) => {
  const fnName = WEBHOOK_FUNCTION_BY_TRIGGER[triggerApiName] || "shopify_webhook";
  const address = buildFunctionUrl(fnName, zapikey, settingId, shop, dataCenterUrl);
  return { setting_id: settingId, address };
};
